// Event bus migrated to mitt for Vue 3 compatibility
import mitt from 'mitt'
const emitter = mitt()
export default emitter